import React from "react";

export default (props) => {//shows signature and its details
    let Signature = props.Signature
    if (Signature.Show) {
        return (
            <div className='col border border-dark'>
                <div>{Signature.Description}</div>
                <img src={Signature.Url} width='250' height='70' className='sign' alt="sign"/>
                <div>{Signature.UpdateAt}</div>
                <div>{Signature.Text}</div>
            </div>
        )
    } else {
        return (<></>)
    }
}